import createStyles from "@mui/styles/createStyles";

export const useStyles = (theme) =>
  createStyles({
    accordianSection: {
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0.5, 0.5, 0.5),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      borderRadius: theme.spacing(0.5),
    },
    // accordianGreen: {
    //   backgroundColor: "#1a871a",
    // },
    autoPay: {
      backgroundColor: "#05B050",
      color: "#FFFFFF",
      padding: theme.spacing(1, 1, 1, 1),
    },
    autoPayIcon: {
      color: "#05B050",
      fontSize: "40px",
    },
    backStep: {
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#d4d3d3",
      },
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(0, 2, 0, 0),
      },
      [theme.breakpoints.up("sm")]: {
        margin: theme.spacing(0, 4, 0, 0),
      },
      [theme.breakpoints.up("md")]: {
        margin: theme.spacing(0, 6, 0, 0),
        padding: theme.spacing(1),
      },
    },
    badgeBox: {
      backgroundColor: "#d4d3d3",
      padding: theme.spacing(0),
      borderRadius: "16px",
      minWidth: "140px",
      textAlign: "center",
    },
    bigCtaBox: {
      margin: theme.spacing(5, 0, 0),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    button: {
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        padding: "14px 16px",
      },
      [theme.breakpoints.up("sm")]: {
        padding: "14px 34px",
      },
      [theme.breakpoints.up("md")]: {
        padding: "14px 34px",
      },
    },
    buttonBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      // marginTop: "60%",
    },
    buttonText: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    buyButton: {
      borderRadius: "1vh",
    },
    borderContainter: {
      border: "1px solid #f3f3f3",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    borderBgColorContainer: {
      backgroundColor: "#f8f8f875",
      border: "1px solid #f3f3f3",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    capturePhoto: {
      width: "50px",
      height: "50px",
      backgroundColor: "#C00001",
      borderRadius: "50px",
      border: "5px solid #000000",
    },
    cardContainer: {
      margin: theme.spacing(0, 1),
      padding: theme.spacing(1),
      borderRadius: "8px",
      background: "#FFFFFF", //"#f3f3f347",
      // background: "#f0f5fb",
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
      [theme.breakpoints.down("sm")]: {
        // height: "40%"
      },
      [theme.breakpoints.up("sm")]: {},
      [theme.breakpoints.up("md")]: {},
    },
    cardItem: {
      borderRadius: "10px",
      padding: "4px",
      background: "#ffd900",
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
      transform: "scale(1)",
      "&:hover": {
        border: "1px solid #ffd900",
        transition: "width 1s, height 1s, transform 1s",
        transform: "scale(1.15)",
      },
    },
    checkButton: {
      backgroundColor: "#004fb6",
      borderRadius: theme.spacing(0.5),
      color: "#ffffff !important",
      padding: theme.spacing(0.5, 1),
      minWidth: theme.spacing(17),
      textAlign: "center",
    },
    checked: {
      color: "#05B050",
    },
    customBtn: {
      display: "flex",
      // flexDirection: "reverse-row",
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
        padding: theme.spacing(2, 0, 2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        justifyContent: "center",
        padding: theme.spacing(2, 0, 2, 0),
      },
      [theme.breakpoints.up("md")]: {
        // position: 'relative',
        height: "100%",
        justifyContent: "center",
        padding: theme.spacing(2, 0, 2, 0),
      },
      position: "relative",
      marginTop: "60%",
    },
    container: {
      justifyContent: "center",
      // backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 0),
      height: "882px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    containerInner: {
      justifyContent: "center",
      // backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 0),
      height: "525px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    containerButtonNew: {
      position: "absolute",
      bottom: 4,
      left: 4,
      right: 4,
      width: "98%",
    },
    containerChild: {
      justifyContent: "center",
      // backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 0),
      height: "520px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    containerButton: {
      position: "fixed",
      bottom: theme.spacing(0.5),
      width: "97.6%",
      left: 4,
      right: 4,
      // bgcolor: "background.paper",
      py: 2,
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    contentScroller: {
      justifyContent: "center",
      // backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 0),
      height: "466px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    cursorPointer: {
      cursor: "pointer",
    },
    disabled: {
      opacity: 0.6,
    },
    errorMsg: {
      height: "20px",
      color: "#ff585d !important",
    },
    formBox: {
      maxWidth: "100%",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(5, 0),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(5, 3),
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(5, 10),
      },
    },
    formControl: {
      margin: theme.spacing(3),
    },
    formBoxInner: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      maxWidth: "600px",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1, 0),
        width: "auto",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(1, 0),
        width: "auto",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(1, 0),
        width: "100%",
      },
    },
    formGroupDate: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
        width: "50%",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2),
        width: "50%",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(2, 0),
        width: "50%",
      },
    },
    gridLabel: {
      width: "100% !important",
      textAlign: "left !important",
      display: "flex !important",
      flexDirection: "column !important",
      justifyContent: "center !important",
    },
    gridChip: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      textAlign: "right",
    },
    gutterBottom: {
      width: "100%",
      padding: theme.spacing(0, 0, 5, 0),
    },
    gutterSectionTop: {
      width: "100%",
      padding: theme.spacing(5, 0, 0),
    },
    gutterTop: {
      width: "100%",
      padding: theme.spacing(1.5, 0, 0),
    },
    headerBox: {
      maxWidth: "725px",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(3, 3, 0),
        textAlign: "left",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(3, 3),
        textAlign: "center",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(5, 10),
        textAlign: "center",
      },
    },
    headerText: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      maxWidth: "600px",
    },
    layoutColumn: {
      layout: "row",
    },
    loaderBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    },
    main: {
      // alignItems: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      padding: theme.spacing(0, 1),
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1.5, 1),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(1.5, 1),
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(0, 1),
      },
    },
    mainCta: {
      width: "100%",
      whiteSpace: "nowrap",
      padding: theme.spacing(0, 3),
    },
    marginTop60: {
      marginTop: "60%",
    },
    marginTop20: {
      marginTop: "20%",
    },
    minHeight: {
      height: "74vh",
    },
    performanceCardsBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: theme.spacing(5, 0),
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        width: "auto",
      },
      [theme.breakpoints.up("lg")]: {
        flexDirection: "row",
        width: "auto",
      },
    },
    performanceCards: {
      // boxShadow: "8px 8px 5px #ECF0F4",
      minWidth: "200px",
      // backgroundColor: "#fbfafa", //"#f4f5f5",
      // textAlign: "left",
      borderRadius: "3vh",
      border: "2px solid #f7f7f7",
      [theme.breakpoints.down("sm")]: {
        width: "80%",
        margin: theme.spacing(2),
        padding: theme.spacing(3, 4),
      },
      [theme.breakpoints.up("md")]: {
        width: "auto",
        margin: theme.spacing(0, 2),
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up("lg")]: {
        width: "auto",
        margin: theme.spacing(0, 2),
        padding: theme.spacing(3),
      },
    },
    policyIssuance: {
      backgroundColor: "#0071C0",
      color: "#FFFFFF",
      padding: theme.spacing(1, 1, 1, 1),
      width: "50%",
    },
    productName: {
      // display: "flex",
      fontSize: "18px",
      margin: theme.spacing(2, 0, 1, 0),
      padding: theme.spacing(1, 0, 1, 0),
      backgroundColor: "#ffd900",
      borderRadius: theme.spacing(0.5),
    },
    planBox: {
      border: "1px solid #ECF0F4",
      borderRadius: "20px",
      padding: theme.spacing(2),
      margin: theme.spacing(2, 0),
      boxShadow: "0 12px 31px 0 rgb(0 37 91 / 13%)",
    },
    policyDateBox: {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        width: "46%",
      },
      [theme.breakpoints.up("lg")]: {
        flexDirection: "row",
        width: "46%",
      },
    },
    policyDateDetailsBox: {
      display: "flex",
      alignItems: "start",
      justifyContent: "space-between",

      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        width: "100%",
      },
      [theme.breakpoints.up("lg")]: {
        flexDirection: "row",
        width: "100%",
      },
    },
    premiumBox: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "row",
        width: "100%",
        justifyContent: "flex-start",
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
        width: "100%",
        justifyContent: "flex-end",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        width: "40%",
        justifyContent: "flex-end",
      },
    },
    productTitle: {
      backgroundColor: "#ffd900",
      padding: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
    },
    question: {
      margin: theme.spacing(1, 0, 1, 0),
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: "18px",
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "18px",
      },
    },
    screenshotIcon: {
      color: "#05B050",
      fontSize: "20px",
    },
    smallText: {
      fontSize: "13px",
    },
    spacing: {
      margin: theme.spacing(0, 0, 1),
    },
    summaryText: {
      borderRadius: theme.spacing(1),
      border: "1px solid #cccccc",
      padding: theme.spacing(1),
      backgroundColor: "#004fb6",
      color: "#ffffff",
    },
    textField: {
      width: "100%",
      "&:MuiInputBase-root": {
        fontWeight: "400 !important",
      },
    },
    textFieldSmall: {
      "&:MuiInputBase-root": {
        fontWeight: "400 !important",
        borderColor: "#eb5757 !important",
      },
      [theme.breakpoints.down("sm")]: {
        width: "50vw",
      },
      [theme.breakpoints.up("md")]: {
        width: "100%",
      },
      [theme.breakpoints.up("lg")]: {
        width: "100%",
      },
    },
    webcamContainer: {
      // backgroundColor: "#FFFFFF",
      width: "220px",
      padding: "15px 5px 10px 5px",
      border: "1px solid #FFFFFF",
      borderTop: "0px",
      backgroundColor: "#F3F3F3",
      boxShadow: "10px 10px 5px #aaaaaa",
    },
    width100: {
      width: "100%",
    },
    absoluteContainer: {
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      position: "fixed",
      width: "100%",
      bottom: "10%",
    },
    containerProduct: {
      justifyContent: "center",
      padding: theme.spacing(2, 0),
      maxHeight: "85vh", // Responsive height
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    scrollableContainer: {
      maxHeight: "85vh", // Responsive height
      overflowY: "auto",
      width: "100%",
      scrollbarWidth: "thin", // Firefox
      scrollbarColor: "#888 #f1f1f1", // Firefox
      "&::-webkit-scrollbar": {
        width: 8,
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: 4,
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
    },
    calculatorCard: {
      border: "1px solid #e0e0e0",
      borderRadius: theme.spacing(2),
      boxShadow: "0 2px 8px #0000000a",
      padding: theme.spacing(3, 2),
      background: "#fff",
      marginBottom: theme.spacing(3),
    },
    iframeLoadingContent: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "70%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
    },
    iframeContainer: {
      height: "90vh",
      width: "100vw",
      top: 0,
      position: "absolute",
    },
  });
